export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9522.4e576a3a.jpg";